import CustomerdataModelBase from '../_generated/modelBases/customerdata-model-base';

export default class CustomerdataModel extends CustomerdataModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
